import * as XLSX from "xlsx";

const pad = (value: number) => String(value).padStart(2, "0");

// SheetJS can't render some date formats (e.g. "dd.mm.yyyy"), so date cells are formatted here from
// their serial value. Other cells keep the text the file's own number format gives them.
const formatCell = (cell?: XLSX.CellObject): string => {
  if (!cell) return "";

  if (cell.t === "n" && cell.z && XLSX.SSF.is_date(cell.z)) {
    const { d, m, y, H, M } = XLSX.SSF.parse_date_code(cell.v);
    const date = `${pad(d)}.${pad(m)}.${y}`;

    return H || M ? `${date} ${pad(H)}:${pad(M)}` : date;
  }

  return cell.w ?? String(cell.v ?? "");
};

// Non-empty rows of the first sheet as display text, header row first.
export const readFirstSheet = async (blob: Blob): Promise<string[][]> => {
  const workbook = XLSX.read(await blob.arrayBuffer(), { type: "array", cellNF: true });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];

  if (!sheet?.["!ref"]) return [];

  const range = XLSX.utils.decode_range(sheet["!ref"]);
  const rows: string[][] = [];

  for (let r = range.s.r; r <= range.e.r; r++) {
    const row: string[] = [];

    for (let c = range.s.c; c <= range.e.c; c++) {
      row.push(formatCell(sheet[XLSX.utils.encode_cell({ r, c })]));
    }

    if (row.some(Boolean)) rows.push(row);
  }

  return rows;
};

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
